import type { SigninArgsWithState } from '@uipath/auth-core';
import type { PropsWithChildren } from 'react';
import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { useUserManager } from './AuthProps';

interface AuthGuardProps {
    extraSigninRequestArgs?: SigninArgsWithState;
}

export const AuthGuard = ({
    children, extraSigninRequestArgs,
}: PropsWithChildren<AuthGuardProps>) => {
    const {
        isAuthenticated, isLoading, error, activeNavigator,
    } = useAuth();

    const { signinComplete } = useUserManager();

    useEffect(() => {
        const isSigningOut = activeNavigator === 'signoutRedirect';

        // if user is not authenticated, try signing in
        if (isSigningOut || isAuthenticated || isLoading) {
            return;
        }

        // sign in silent or with redirect, depending on valid session
        signinComplete(extraSigninRequestArgs);

        // error added as a dependency to force retry
    }, [ error, isLoading, isAuthenticated, activeNavigator, signinComplete, extraSigninRequestArgs ]);

    if (isAuthenticated) {
        // wrap in fragment to cast to JSX.Element
        return <>
            {children}
        </>;
    }

    // TODO: add loader
    return null;
};
